import React from 'react';
import {ReactComponent as Icon} from 'images/icon/progress-marker.svg';
import classNames from 'classnames';

export default class ProgressMarker extends React.PureComponent {
  render() {
    return (
      <Icon
        ref={this.props.iconRef}
        className={classNames('icon progress-marker', this.props.className)}
      />
    );
  }
}
